import { Component, OnInit, Input, EventEmitter, Output, SimpleChanges } from '@angular/core';
import { Widget } from '../../../models/form';
import { FormControl, Validators, FormBuilder, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-combo-box',
  templateUrl: './combo-box.component.html',
  styleUrls: ['./combo-box.component.scss']
})
export class ComboBoxComponent {
  @Input() formGroup: FormGroup
  @Input() addable: boolean = false;
  @Input() widget: Widget;
  @Input() data: any = {};
  @Output() updateData = new EventEmitter();


  public formGroups: Array<FormGroup>;
  //public ownData = {}


  private timeoutChange = null



  constructor(private fb: FormBuilder) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.addable) {
      if (this.data == null || Object.keys(this.data).length == 0) {
        this.initdata();
      }
      this.initOwns();
      this.initFormCtrl();
    }

  }
  initFormCtrl() {
    let keys = Object.keys(this.data);
    this.formGroups = [];
    for (let tabKey in this.data[keys[0]]) {
      let tabKeyNum = parseInt(tabKey);
      let settable = true;
      for (let key of keys) {
        if (!(tabKeyNum in this.data[key])) {
          settable = false;
          break;
        }
      }
      if (settable) {
        let formG = {};
        for (let key of keys) {
          formG[key] = [this.data[key][tabKeyNum], Validators.required];
        }
        this.formGroups[tabKeyNum] = this.fb.group(formG)
        this.formGroups[tabKeyNum].valueChanges.subscribe(data => {
          if (this.formGroups[tabKeyNum].status == "VALID") {
            console.log(this.data, data);
            for (let key in data) {
              if (key in this.data) {
                this.data[key][tabKeyNum] = data[key]
              }
            }
            this.sendData();
          }
          else {
            console.warn("no setted");
          }
        });
      }

    }
  }

  initdata() {
    //console.log(this.widget.values)
    this.data = {};
    console.log("inited", this.widget.values);
    for (let value of this.widget.values) {
      //this.data[(<any>value).param] = [null];
      if ("param" in <any>value) {
        this.data[(<any>value).param] = [null];
      }
    }
    console.log("inited", this.data);
  }
  initOwns() {



  }
  add() {
    console.log(this.widget.values)
    for (let value of this.widget.values) {
      //this.data[(<any>value).param] = [null];
      if ("param" in <any>value) {
        this.data[(<any>value).param].push(null);
      }
    }
    this.initOwns();
    this.initFormCtrl();
  }

  getUnlikedObj(arr: Array<any>) {
    let tab = []
    for (let elem of arr) {
      let obj = {}
      Object.assign(obj, elem);
      tab.push(obj);
    }
    return tab;
  }

  sendData() {

    clearTimeout(this.timeoutChange);
    this.timeoutChange = setTimeout(() => {

      this.updateData.emit(this.data);
      console.log("send data", this.data);


    }, 500)

  }
  // update manuel
  updateDataObj(data) {
    console.log(data);
    this.sendData();

  }
}



// WEBPACK FOOTER //
// C:/Users/Quentin/projets/kontractor/src/app/components/form/combo-box/combo-box.component.ts